import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { calculateWordsFromString } from "../../../utils/Helper";

export const useJenkins = ({ setShowRequestPopup, callApi, editData, projectOpts }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [jenkinsRequestData, setJenkinsRequestData] = useState({ project_id: 0, jenkins_request_id: 0, environment_id: [] });
    const [options, setOptions] = useState({});
    const [previousData, setPreviousData] = useState({});
    const [edit, setEdit] = useState(true);
    const [loader, setLoader] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target
        setEdit(false)
        if (name === "project_id") {
            setJenkinsRequestData((prev) => ({ ...prev, [name]: value, "environment_id": [], "jenkins_type_ids": {}, "jenkins_sub_type_ids": [], "jenkins_job_ids": [], "jenkins_approver_list": '' }))
        } else if (name === "environment_id") {
            setJenkinsRequestData((prev) => ({ ...prev, [name]: value, "jenkins_sub_type_ids": [], "jenkins_type_ids": {}, "jenkins_job_ids": [] }))
        } else if (name === "jenkins_type_ids") {
            setJenkinsRequestData((prev) => ({ ...prev, [name]: value, "jenkins_sub_type_ids": [], "jenkins_job_ids": [] }))
        } else if (name === "jenkins_sub_type_ids") {
            setJenkinsRequestData((prev) => ({ ...prev, [name]: value, "jenkins_job_ids": [] }))
        } else {
            setJenkinsRequestData((prev) => ({ ...prev, [name]: value }))
        }
    }

    useEffect(() => {
        if (editData !== undefined && editData !== null) {
            const projectId = _.findWhere(projectOpts, { project_id: editData?.project_id })
            const data = {
                "jenkins_request_id": editData?.jenkins_request_id,
                "project_id": projectId,
                "reason": editData?.reason,
                "approver_user_code": editData?.approver_user_code,
                "environment_id": ''
            }
            setJenkinsRequestData(data);
            setPreviousData(data);
            GetJenkinsEnvType(editData?.project_id, editData?.environment_id, editData?.jenkins_type_id, editData?.jenkins_sub_type_id)
        } else {
            setEdit(false)
            setJenkinsRequestData({ project_id: 0, jenkins_request_id: 0, environment_id: [] });
        }
    }, [editData])


    useEffect(() => {
        if (jenkinsRequestData?.project_id !== 0 && !edit) {
            GetJenkinsEnvType()
        }
    }, [jenkinsRequestData?.project_id, jenkinsRequestData?.environment_id, jenkinsRequestData?.jenkins_type_ids, jenkinsRequestData.jenkins_sub_type_ids]);

    const GetJenkinsEnvType = async (projectId, envId, jenkisType, subType) => {
        const payload = {
            "project_id": projectId ? projectId : jenkinsRequestData?.project_id?.project_id || 0,
            "environment_id": envId ? envId : jenkinsRequestData?.environment_id?.environment_id?.toString() || '',
            "jenkins_type_id": jenkisType ? jenkisType : jenkinsRequestData?.jenkins_type_ids?.jenkins_type_id?.toString() || '',
            "jenkins_sub_type_id": subType ? subType : jenkinsRequestData.jenkins_sub_type_ids?.jenkins_sub_type_id?.toString() || '',
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETJENKINSENVTYPE"), payload);
            if (res?.status === 200) {
                setOptions((prev) => ({
                    ...prev,
                    envOption: res?.body?.data?.project_env_list,
                    jenkinsTypeOption: res?.body?.data?.jenkins_env_list,
                    jenkinsSubTypeOption: res?.body?.data?.jenkins_subtype_env_list,
                    jenkinsJobTypeOption: res?.body?.data?.jenkins_job_type,
                    approverOption: res?.body?.data?.jenkins_approver_list
                }))
                if (projectId || envId || jenkisType) {
                    const idsArray = editData?.job_id?.split(',').map(id => parseInt(id?.trim()))
                    const data = {
                        "environment_id": _.findWhere(res?.body?.data?.project_env_list, { environment_id: editData?.environment_id }),
                        "jenkins_type_ids": _.findWhere(res?.body?.data?.jenkins_env_list, { jenkins_type_id: editData?.jenkins_type_id }),
                        "jenkins_sub_type_ids": editData?.jenkins_sub_type_id && _.findWhere(res?.body?.data?.jenkins_subtype_env_list, { jenkins_sub_type_id: editData?.jenkins_sub_type_id }) || "",
                        "jenkins_job_ids": editData?.job_id !== 0 ? _.filter(res?.body?.data?.jenkins_job_type, job => _.contains(idsArray, job.job_id)) : []
                    }
                    setJenkinsRequestData((prev) => ({ ...prev, ...data }))
                    setPreviousData((prev) => ({ ...prev, ...data }))
                }
            }
        } catch (error) {
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }

    const jenkinsRequestUpsert = async () => {
        if (_.isEqual(jenkinsRequestData, previousData)) {
            showInfo("info", "No changes made");
            return;
        }
        if (jenkinsRequestData?.project_id === 0) {
            showInfo("info", "Please select project.");
            return;
        }
        if (!jenkinsRequestData?.environment_id?.environment_id) {
            showInfo("info", "Please select an env.");
            return;
        }
        if (!jenkinsRequestData?.jenkins_type_ids?.jenkins_type_id) {
            showInfo("info", "Please select a jenkins type.");
            return;
        }
        if (jenkinsRequestData?.approver_user_code === undefined || jenkinsRequestData?.approver_user_code === 0) {
            showInfo("info", "Please select an approver.");
            return;
        }
        if ((jenkinsRequestData.reason && calculateWordsFromString(jenkinsRequestData.reason) < 5) || !jenkinsRequestData.reason) {
            showInfo("info", "Reason should contain minimum 5 words.");
            return;
        }

        try {
            setLoader(true)
            const payload = {
                "jenkins_request_id": jenkinsRequestData?.jenkins_request_id,
                "environment_id": jenkinsRequestData?.environment_id?.environment_id,
                "jenkins_type_id": jenkinsRequestData?.jenkins_type_ids?.jenkins_type_id,
                "jenkins_sub_type_id": jenkinsRequestData?.jenkins_sub_type_ids?.jenkins_sub_type_id || 0,
                "job_ids": _.pluck(jenkinsRequestData?.jenkins_job_ids, 'job_id').toString() || "",
                "reason": jenkinsRequestData?.reason,
                "approver_user_code": jenkinsRequestData?.approver_user_code,
                "jenkins_job_request_id": editData?.jenkins_job_request_id
            }
            const res = await services.getInvokeRemote("POST", Urls("JENKINSREQUESTUPSERT"), payload);
            if (!res?.body?.error_status) {
                setLoader(false);
                showSuccess("success", res?.body?.message);
                callApi();
                setShowRequestPopup(false);
                setJenkinsRequestData({
                    jenkins_request_id: 0,
                    "project_id": 0,
                });
            } else {
                setLoader(false);
                showError("error", res?.body?.errorMessage);
                return;
            }
        } catch (error) {
            setLoader(false);
            showError('Error', error?.response?.data?.errorMessage);
            console.error("Error:", error);
        }
    }

    const handleEvent = (value, type) => {
        setJenkinsRequestData((prev) => ({ ...prev, [type]: [] }))
    }

    return useMemo(() => ({
        jenkinsRequestUpsert, handleChange, options, jenkinsRequestData, handleEvent, loader
    }), [jenkinsRequestUpsert, handleChange, options, jenkinsRequestData, handleEvent, loader]);
}